import React from "react";
import "./HomeProjects.scss";
import Heading from "../Heading/Heading";
import Button from "../Button/Button";
import Carousel from "../Carousel/Carousel";
import { CarouselContents } from "../Carousel/carouselContents";
import { Link } from "react-router-dom";

export default function HomeProjects() {
  return (
    <div className="homepage__projects">
      <Heading content="Projects" />
      <section className="projects__content">
        <div className="projects__left">
          <p className="projects__text">
            Here’s a quick glance at some of the work I’ve done. With every
            project I strive for excellence in both functionality and in design.
            Click the button below to see more details.
          </p>
          <Link to="/projects">
            <Button
              content="My Projects"
              classtitle="button button--primary button__projects"
            />
          </Link>
        </div>
        <div className="projects__right">
          <Carousel items={CarouselContents} />
        </div>
      </section>
    </div>
  );
}
